module.exports = __webpack_public_path__ + "DINNextLTPro-Italic.ttf?dcd9077f38bfc0c7922e63885e6bd65a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Italic.ttf
// module id = 1405
// module chunks = 0